import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from './motionPresets';

export default function FinalCtaSection() {
  return (
    <section className="py-20 lg:py-28 bg-gradient-to-br from-indigo-600 to-indigo-800 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-[400px] h-[400px] bg-white rounded-full blur-[100px]" />
        <div className="absolute bottom-0 right-1/4 w-[300px] h-[300px] bg-sky-300 rounded-full blur-[80px]" />
      </div>
      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <motion.div {...fadeUp} transition={{ duration: 0.5 }}>
          <h2 className="text-3xl lg:text-5xl font-bold text-white tracking-tight mb-6">
            Start Managing PAF<br />Compliance Today
          </h2>
          <p className="text-lg text-indigo-100 mb-10 max-w-2xl mx-auto">
            Join hundreds of companies that trust PAFHub to stay compliant and audit-ready. Start your free trial today.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 bg-white hover:bg-indigo-50 text-indigo-600 font-semibold rounded-xl transition-all shadow-lg text-[15px]" data-testid="cta-demo-btn">
              Request Demo <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-xl border border-white/20 transition-all text-[15px]">
              Contact Sales
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
